export function handlePlural(
  count: number,
  singular: string,
  plural: string,
  includeCount = true
) {
  const countString = includeCount ? `${count} ` : '';
  return `${countString}${count === 1 ? singular : plural}`;
}
